export interface DocumentMetadata {
  documentType: string;
  documentName: string;
  documentId: string;
}

export interface TagMetadata {
  documents?: DocumentMetadata[];
  missingTypes?: string[];
  [key: string]: any;
}

export interface Tag {
  _id: string;
  tagId: string;
  tagName: string;
  tagType: string;
  description: string;
  entityType: string;
  entityId: string;
  metadata: TagMetadata;
  createdAt: string;
}

export interface TagsByEntity {
  [entityId: string]: Tag[];
}

export const TAG_ENTITY_TYPES = {
  TRANSACTION: 'TRANSACTION',
  DOCUMENT: 'DOCUMENT',
};

export const TAG_NAMES = {
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  MISSING_DOCUMENT: 'MISSING_DOCUMENT',
  NEW_DOCUMENT_ADDED_TODAY: 'NEW_DOCUMENT_ADDED_TODAY',
  DOCUMENT_REJECTED_SENT_TO_AGENT: 'DOCUMENT_REJECTED_SENT_TO_AGENT',
  STAGNANT_TRANSACTION: 'STAGNANT_TRANSACTION',
  CHECK_DOCUMENT: 'CHECK_DOCUMENT',
  COMPLIANCE_TRANSACTION: 'COMPLIANCE_TRANSACTION',
  READY_FOR_USER_REVIEW: 'READY_FOR_USER_REVIEW',
  MAX_APPROVED: 'MAX_APPROVED',
  EXPIRED: 'EXPIRED',
  LISTING_EXPIRED: 'LISTING_EXPIRED',
  MISSING_DOCS_AGENT: 'MISSING_DOCS_AGENT',
  MISSING_DOCS_PROCESSOR: 'MISSING_DOCS_PROCESSOR',
  MISSING_DOCS_CLOSING_MEMBER: 'MISSING_DOCS_CLOSING_MEMBER',
};

export const TAG_DISPLAY_NAMES = {
  VALIDATION_FAILED: 'Validation Failed',
  MISSING_DOCUMENT: 'Missing Document',
  NEW_DOCUMENT_ADDED_TODAY: 'New Document Added',
  DOCUMENT_REJECTED_SENT_TO_AGENT: 'Document Rejected',
  STAGNANT_TRANSACTION: 'Dormant Transaction',
  CHECK_DOCUMENT: 'Check Transaction',
  COMPLIANCE_TRANSACTION: 'Compliance Transaction',
  MAX_APPROVED: 'Ready for User Review',
  READY_FOR_USER_REVIEW: 'Ready for User Review',
  EXPIRED: 'Expired',
  LISTING_EXPIRED: 'Listing Expired',
  NEW_AGENT: 'New Agent',
  MISSING_DOCS_AGENT: 'Agent Missing Docs',
  MISSING_DOCS_PROCESSOR: 'Processor Missing Docs',
  MISSING_DOCS_CLOSING_MEMBER: 'Closing Team Missing Docs',
};

// Tags related to compliance that should be hidden when compliance is disabled
export const COMPLIANCE_TAGS = [
  TAG_NAMES.VALIDATION_FAILED,
  TAG_NAMES.DOCUMENT_REJECTED_SENT_TO_AGENT,
  TAG_NAMES.MAX_APPROVED,
];

// Owner-specific missing doc tags - hidden when enableDocumentOwnership is disabled
export const OWNER_MISSING_DOC_TAGS = [
  TAG_NAMES.MISSING_DOCS_AGENT,
  TAG_NAMES.MISSING_DOCS_PROCESSOR,
  TAG_NAMES.MISSING_DOCS_CLOSING_MEMBER,
];
